import { createReducer } from './utils';
import { SNACK_SET, CUSTOM_SNACKBAR } from './constants';

const defaultState = {
  snack: { open: false, severity: null, message: null },
};

export const reducer = createReducer(defaultState, {
  [SNACK_SET]: handleSnackSet,
  [CUSTOM_SNACKBAR]: handleCustomSnackbar,
});

function handleSnackSet(state, { payload: { snack } }) {
  return {
    ...state,
    snack,
  };
}

function handleCustomSnackbar(state, { payload: { text, color } }) {
  return {
    ...state,
    snack: { open: true, translation_key: text, severity: color },
  };
}

export function setSnackAlert(snack) {
  return async dispatch => {
    dispatch({
      type: SNACK_SET,
      payload: { snack },
    });
  };
}
